module.exports = __webpack_public_path__ + "static/images/paypal.1YwPvIl.svg";